import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, Lock, ArrowRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import api from '../lib/api';
import './Login.css';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_eventbooth-app/artifacts/q2jc85s9_1768277124501.png';

export default function Login() {
  const navigate = useNavigate();
  const { login, adminLogin } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isAdmin) {
        await api.adminLogin(formData.email, formData.password);
        adminLogin(formData.email);
        navigate('/admin');
      } else {
        // For customer login, just store email
        login({ email: formData.email, name: formData.email.split('@')[0] });
        navigate('/my-bookings');
      }
    } catch (err) {
      setError(err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <motion.div
          className="login-card"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link to="/" className="login-logo">
            <img src={LOGO_URL} alt="Luxe Lens Events" />
          </Link>

          <h1 className="login-title">
            {isAdmin ? 'Admin Login' : 'Welcome Back'}
          </h1>
          <p className="login-subtitle">
            {isAdmin
              ? 'Access your admin dashboard'
              : 'Sign in to manage your bookings'}
          </p>

          <div className="login-tabs">
            <button
              className={`tab-btn ${!isAdmin ? 'active' : ''}`}
              onClick={() => setIsAdmin(false)}
            >
              Customer
            </button>
            <button
              className={`tab-btn ${isAdmin ? 'active' : ''}`}
              onClick={() => setIsAdmin(true)}
            >
              Admin
            </button>
          </div>

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email</label>
              <div className="input-with-icon">
                <Mail size={18} />
                <input
                  type="email"
                  className="form-input"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                />
              </div>
            </div>

            {isAdmin && (
              <div className="form-group">
                <label className="form-label">Password</label>
                <div className="input-with-icon">
                  <Lock size={18} />
                  <input
                    type="password"
                    className="form-input"
                    placeholder="Enter your password"
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    required
                  />
                </div>
              </div>
            )}

            <button type="submit" className="btn btn-primary w-full" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
              <ArrowRight size={18} />
            </button>
          </form>

          <div className="login-footer">
            <p>
              Don't have bookings yet?{' '}
              <Link to="/book">Book an event</Link>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
